"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { dropdownRecipe } from '../../recipes/dropdown.mjs';

const ListHeader = forwardRef(
  ({ children, className, ...props }, ref) => {
    const styles = dropdownRecipe();
    return /* @__PURE__ */ jsx("span", { className: clsx(styles["items-list-header"], className), role: "heading", "aria-level": 2, ref, ...props, children });
  }
);

export { ListHeader };
